import React from 'react'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

import './calender.css'


function Calender() {
    return(
        <div className={'calenderDiv'}>
            <div className={'calender'}>
                <FullCalendar
                    plugins={[ dayGridPlugin]}
                    initialView="dayGridMonth"
                    events={[
                        { title: 'event 1', date: '2022-06-01' },
                        { title: 'event 2', date: '2022-06-22' }
                    ]}
                />
            </div>
        </div>
    )
}
export default Calender;